import React from 'react';
import { List } from 'semantic-ui-react';
import RequestStatusReasonListItem from '../containers/RequestStatusReasonListItem';
import RequestStatusUpdatedOnListItem from '../containers/RequestStatusUpdatedOnListItem';

const RequestOutcomeList = ({ category, code }) => (
  <List className="aridhia-request-outcome-list">
    <RequestStatusReasonListItem code={code} category={category} />
    <RequestStatusUpdatedOnListItem code={code} category={category} />
  </List>
);

export default RequestOutcomeList;
